import { css } from '@emotion/react';
import { Box, styled } from '@mui/material';
import type { ReactNode } from 'react';

import { MAIN_BREAKPOINT } from '@/modules/MAIN_BREAKPOINT';

const Root = styled(Box)(
  ({ theme }) => css`
    padding: ${theme.spacing(0)} ${theme.spacing(2)} ${theme.spacing(4)};

    ${theme.breakpoints.up(MAIN_BREAKPOINT)} {
      padding: ${theme.spacing(7.75)} ${theme.spacing(13.125)};
    }
  `,
);

interface AdministrationBodyProps {
  children: ReactNode;
}

export function AdministrationBody({ children }: AdministrationBodyProps) {
  return <Root>{children}</Root>;
}
